import { getAnalytics, logEvent } from "firebase/analytics";
import "./NewCasualGames.css";

const NewCasualGames = () => {
  const analytics = getAnalytics();

  return (
    <div
      className="casual_container"
      onPointerOver={() => window.adsbygoogle.push({})}
    >
      <h2>Casual Games</h2>
      <div>
        <a
          href="https://play.amezgame.com/hoopball/index.html"
          rel="noreferrer"
          onClick={() =>
            logEvent(analytics, "Rareprob Casual Games", {
              content_type: "Coloron",
              content_id: "Coloron",
              items: [{ name: "Coloron" }],
            })
          }
        >
          <img src="/images/gamesScreen/hoopball.png" alt="Coloron" />
          <h4>Hoop Ball</h4>
        </a>
        <a
          href="https://play.amezgame.com/shapebuilder/index.html"
          rel="noreferrer"
          onClick={() =>
            logEvent(analytics, "Rareprob Casual Games", {
              content_type: "Coloron",
              content_id: "Coloron",
              items: [{ name: "Coloron" }],
            })
          }
        >
          <img src="/images/gamesScreen/Shapehavoc.png" alt="Coloron" />
          <h4>Shape Havoc</h4>
        </a>
        <a
          href="https://play.amezgame.com/shapeswap/index.html"
          rel="noreferrer"
          onClick={() =>
            logEvent(analytics, "Rareprob Casual Games", {
              content_type: "Coloron",
              content_id: "Coloron",
              items: [{ name: "Coloron" }],
            })
          }
        >
          <img src="/images/gamesScreen/Shapeswitch.png" alt="Coloron" />
          <h4>Shape Switch</h4>
        </a>
        <a
          href="https://play.amezgame.com/buildtower/index.html"
          rel="noreferrer"
          onClick={() =>
            logEvent(analytics, "Rareprob Casual Games", {
              content_type: "Tower Game",
              content_id: "Tower Game",
              items: [{ name: "Tower Game" }],
            })
          }
        >
          <img
            src="https://img.rareprob.com/img/default/RareProbImg/imagesRare/games/towe-Game.webp"
            alt="Tower Game"
          />
          <h4>Tower Game</h4>
        </a>
      </div>
    </div>
  );
};

export default NewCasualGames;
